import { APIService } from '@apparel/core/api';
import { localStorage } from '@apparel/core/storage';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useFormikContext } from 'formik';
import { uniqBy } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Label } from './../auth/AuthButtons/NewAuthForm/Forms/SignUp';

export const CountriesDropdown = ({
    name,
    menuClassName,
    required = false,
}: {
    name: string;
    menuClassName?: string;
    required?: boolean;
}) => {
    const DEFAULT_COUNTRY_ID = 236;
    const formik = useFormikContext<any>();
    const storageKey = '@countries.get.request_v2';
    const [countries, setCountries] = useState([]);
    const country = formik.getFieldMeta<string>(name);
    const countryMeta = formik.getFieldHelpers<string>(name);

    useEffect(() => {
        if (localStorage.getItem(storageKey)) {
            setCountries(localStorage.getItem(storageKey));
        } else {
            APIService.api.get('countries').then(({ data }) => {
                const countriesData = uniqBy(data, 'id');
                const defaultCountryIndex = countriesData.findIndex(
                    (country: any) => country.id === DEFAULT_COUNTRY_ID,
                );
                const defaultCountry = countriesData.splice(defaultCountryIndex, 1)[0];
                countriesData.splice(0, 0, defaultCountry);
                setCountries(countriesData);
                localStorage.setItem(storageKey, countriesData);
            });
        }
    }, []);

    const handleChange = useCallback(
        (event, value) => {
            countryMeta.setValue(value);
        },
        [countryMeta],
    );

    return (
        <>
            <Label>
                Country
                {required ? <span style={{ color: '#FF0000', marginLeft: 4 }}>*</span> : null}
            </Label>
            <Autocomplete
                id="country-select"
                style={{ width: '100%' }}
                options={countries}
                classes={menuClassName ? { popper: menuClassName } : undefined}
                getOptionLabel={(country) => country.name}
                onChange={handleChange}
                value={country?.value}
                renderInput={(params) => (
                    <InputField
                        {...params}
                        variant="outlined"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ ...params.inputProps }}
                    />
                )}
            />

            {country.touched && country.error ? (
                <FormHelperText error={true}>{'Required Field!'}</FormHelperText>
            ) : null}
        </>
    );
};

const InputField = styled(TextField)`
    && {
        .MuiOutlinedInput-root {
            border-radius: 4px;
            padding: 1px 1px 1px 14px;
        }
    }
`;
